import { server_connection } from 'config';

export const UPDATE_QUALIFICATION_FORM  = '[COMPANY APP] UPDATE QUALIFICATION FORM';
export const GET_QUALIFICATIONS         = '[COMPANY APP] GET QUALIFICATIONs';

export function updateQualificationForm(company_data) {
    return {
        type: UPDATE_QUALIFICATION_FORM,
        payload: company_data
    }
}

// export function getQualifications(company_id) {
//     return (dispatch, getState) => {
//         fetch(server_connection + '/company/qualifications/list/' + company_id)
//             .then((response) => response.json())
//             .then((qualifications) => {
//                 dispatch({
//                     type: GET_QUALIFICATIONS,
//                     payload: qualifications,
//                 });
//             });
//     }
// }

export function saveQualification(qualification) {
    return async (dispatch, getState) => {
        await fetch(server_connection + '/company/qualification/save',
            {
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                method: 'POST',
                body: JSON.stringify({
                    qualification
                })
            })
            .then((response) => response.json())
            .then((responseData) => {
                // dispatch(getQualifications());
                // dispatch();
            });
    }
}



// WEBPACK FOOTER //
// src/main/content/company/store/actions/qualifications.actions.js